export var Decorator;
(function (Decorator) {
  function checkScroller(err, warning) {
    return (target, methodName, descriptor) => {
      const raw = descriptor.value;
      descriptor.value = function () {
        const scroller = this.scroller.widget;
        if (scroller == null) {
          const msg = `Shoule enable scroller to use method '${methodName}'`;
          if (err !== false) {
            console.error(msg);
            throw new Error(msg);
          }
          if (warning !== false) {
            console.warn(msg);
          }
          return this;
        }
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return raw.call(this, ...args);
      };
    };
  }
  Decorator.checkScroller = checkScroller;
})(Decorator || (Decorator = {}));